/* eslint-disable max-len */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ContentTypography from 'components/Common/ContentTypography';
import HeaderTypography from 'components/Common/HeaderTypography';
import API from 'api';
import BlueButton from 'components/Common/BlueButton';

import { ReactComponent as Facebook } from 'assets/facebook.svg';
import { ReactComponent as Google } from 'assets/google.svg';
import GoogleColorfulLogo from 'assets/GoogleColorfulLogo.png';
import facebookColorfulLogo from 'assets/facebookColorfulLogo.png';

import Styles from './index.module.css';

const fetchAds = async () => {
  const result = await API.ad.postAdList();
  if (result.error) {
    alert(result.error.errorMsg);
    return [[], result.error];
  }
  return result;
};

const subtractDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - days);
  return newDate.toISOString();
};

function InfoBlock({
  platform,
  budgetPerDay,
  remainingBudget,
}) {
  const [googleActiveAdsSum, setGoogleActiveAdsSum] = useState(0);
  const [facebookActiveAdsSum, facebookGoogleActiveAdsSum] = useState(0);
  const [googleEffectCostSum, setGoogleEffectCostSum] = useState(0);
  const [facebookEffectCostSum, setFacebookEffectCostSum] = useState(0);
  const [googleAmount, setGoogleAmount] = useState(() => {
    const amounts = JSON.parse(localStorage.getItem('amounts'));
    if (amounts) {
      return +amounts.google;
    } else {
      return 0;
    }
  });
  const [facebookAmount, setFacebookAmount] = useState(() => {
    const amounts = JSON.parse(localStorage.getItem('amounts'));
    if (amounts) {
      return +amounts.facebook;
    } else {
      return 0;
    }
  });

  useEffect(async () => {
    // Sum of cost of Effect for Google and Facebook startin from 2021.10.01 and always ending by today
    const resultGoogleEffect = await API.ad.getGooglePerformanceData((new Date('October 1, 2021 08:00:00')).toISOString(), (new Date()).toISOString());
    const resultFacebookEffect = await API.ad.getFacebookPerformanceData((new Date('October 1, 2021 08:00:00')).toISOString(), (new Date()).toISOString());
    const sumCostGoogleEffect = resultGoogleEffect.resultData.reduce((accumulator, item) => accumulator + +item.cost, 0);
    const sumCostFacebookEffect = resultFacebookEffect.resultData.reduce((accumulator, item) => accumulator + +item.cost, 0);
    // Sum of daily cost for inline ads for Google and Facebook
    const { resultData } = await fetchAds();
    const filteredData = resultData.filter((item) => item.adStatus === 'Online');
    const googleActiveAdsAmount = filteredData.reduce((acc, item) => {
      if (item.platform === 'Google') {
        return acc + +item.dayBudget;
      } else {
        return acc;
      }
    }, 0);
    const facebookActiveAdsAmount = filteredData.reduce((acc, item) => {
      if (item.platform !== 'Google') {
        return acc + +item.dayBudget;
      } else {
        return acc;
      }
    }, 0);

    const userInfo = await API.auth.getUserInfo();
    if (!userInfo.error) {
      localStorage.setItem('amounts', JSON.stringify({ google: userInfo.resultData.googleAmount, facebook: userInfo.resultData.facebookAmount }));
    }
    const amounts = JSON.parse(localStorage.getItem('amounts'));

    setGoogleActiveAdsSum(googleActiveAdsAmount);
    facebookGoogleActiveAdsSum(facebookActiveAdsAmount);
    setGoogleEffectCostSum(sumCostGoogleEffect);
    setFacebookEffectCostSum(sumCostFacebookEffect);
    localStorage.setItem('effectCostSum', JSON.stringify({ google: sumCostGoogleEffect, facebook: sumCostFacebookEffect }));
  });

  return (
    <div className={Styles.infoContainer_wrapped}>
      <div className={Styles.infoIcon}>
        <div style={{
          color: '#7C98CC', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          {platform === 'Google' && <img style={{ height: '75px', width: '75px' }} src={GoogleColorfulLogo} alt="" /> }
          {platform === 'Facebook' && <img style={{ height: '75px', width: '75px' }} src={facebookColorfulLogo} alt="" />}
        </div>
      </div>
      <div className={Styles.infoContainer}>
        <div className={Styles.infoItem}>
          <ContentTypography style={{ marginBottom: '19px' }}>
            <span className={Styles.infoItemTitle}>上線廣告設定預算</span>
          </ContentTypography>
          <HeaderTypography style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
          }}
          >
            <span className={Styles.infoItemText}>
              $
              {(platform === 'Google' ? googleActiveAdsSum : facebookActiveAdsSum).toLocaleString()}
            </span>
            {' '}
            <span>/ 日</span>
          </HeaderTypography>
        </div>
        <div className={Styles.infoItem}>
          <ContentTypography style={{ marginBottom: '19px' }}>
            <span className={Styles.infoItemTitle}>剩餘預算</span>
          </ContentTypography>
          <HeaderTypography>
            <span className={Styles.infoItemText}>
              $
              {(platform === 'Google' ? Math.round(googleAmount - googleEffectCostSum) : Math.round(facebookAmount - facebookEffectCostSum)).toLocaleString()}
            </span>
          </HeaderTypography>
        </div>
      </div>
    </div>
  );
}

InfoBlock.propTypes = {
  platform: PropTypes.string,
  budgetPerDay: PropTypes.number,
  remainingBudget: PropTypes.number,
};

InfoBlock.defaultProps = {
  platform: 'Google',
  budgetPerDay: 9250,
  remainingBudget: 8900,
};

function TopUpCard() {
  const [id, setId] = useState('');
  useEffect(() => {
    setId(localStorage.getItem('userId'));
  });
  return (
    <>
      <div className={Styles.container}>
        <div className={Styles.item}>
          <InfoBlock platform="Facebook" />
        </div>
        <div className={Styles.buttonItem}>
          <div className={Styles.button}>
            <a target="_blank" href={`https://www.hhgalaxy.com.tw/custom/adsystem/facebook?adid=${id}`} rel="noreferrer">
              <BlueButton>儲值去</BlueButton>
            </a>
          </div>
        </div>
      </div>

      <div className={Styles.container}>
        <div className={Styles.item}>
          <InfoBlock platform="Google" />
        </div>
        <div className={Styles.buttonItem}>
          <div className={Styles.button}>
            <a target="_blank" href={`https://www.hhgalaxy.com.tw/custom/adsystem/google?adid=${id}`} rel="noreferrer"><BlueButton>儲值去</BlueButton></a>
          </div>
        </div>
      </div>
    </>
  );
}

export default TopUpCard;
